import {
  browserLocalPersistence,
  browserSessionPersistence,
  onAuthStateChanged,
  setPersistence,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from "firebase/auth";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../config/firebase";
import { getAuthErrorMessage } from "../utils/authErrors";

const getEmail = (input) => {
  if (input.includes('@')) return input.trim();
  return input.trim() + '@xudoan.com';
};

export const loginWithEmail = async (input, password, rememberMe = true) => {
  const email = getEmail(input);
  try {
    await setPersistence(auth, rememberMe ? browserLocalPersistence : browserSessionPersistence);
    const result = await signInWithEmailAndPassword(auth, email, password);
    const user = result.user;
    const userRef = doc(db, "nguoiDung", user.uid);
    let userDoc = await getDoc(userRef);

    if (!userDoc.exists()) {
      await setDoc(userRef, {
        email: user.email,
        hoTen: user.displayName || email.split('@')[0],
        tenThanh: "",
        vaiTro: ["GVCN"],
        maLopCN: "",
        trangThai: "dangHoatDong",
        namHoc: "2025-2026",
        lanDauDangNhap: false,
        ngayTao: new Date().toISOString(),
      });
      userDoc = await getDoc(userRef);
    }

    const userData = userDoc.data();
    if (userData.trangThai === 'nghi') throw new Error("Tài khoản đã bị vô hiệu hóa. Vui lòng liên hệ ADMIN.");
    
    return { 
      uid: user.uid, email: user.email, ...userData,
      lanDauDangNhap: userData.lanDauDangNhap !== false
    };
  } catch (error) {
    // Dùng module authErrors để trả về thông báo thân thiện
    throw new Error(getAuthErrorMessage(error));
  }
};

export const changePassword = async (newPassword) => {
  const user = auth.currentUser;
  if (!user) throw new Error("Không tìm thấy người dùng.");
  await updatePassword(user, newPassword);
  await updateDoc(doc(db, "nguoiDung", user.uid), { lanDauDangNhap: false });
};

export const logoutUser = () => signOut(auth);

export const onAuthStateChange = (callback) => onAuthStateChanged(auth, callback);

export const getUserData = async (uid) => {
  const userDoc = await getDoc(doc(db, "nguoiDung", uid));
  return userDoc.exists() ? { uid, ...userDoc.data() } : null;
};